import React from 'react';
import { Card, Badge } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { Box } from '@mui/material';

const EventTile = ({ data, onClick, className = "" }) => {
    const handleClick = () => {
        if (onClick) {
            onClick(data);
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return '未定';
        const date = new Date(dateString);
        return date.toLocaleDateString('ja-JP', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    const getEventStatus = (eventDate) => {
        if (!eventDate) return 'scheduled';
        const now = new Date();
        const event = new Date(eventDate);
        
        if (event < now) return 'past';
        if (event.getTime() - now.getTime() < 24 * 60 * 60 * 1000) return 'soon';
        return 'scheduled';
    };

    const status = getEventStatus(data.event_date);
    const statusConfig = {
        'past': { variant: 'secondary', text: '終了' },
        'soon': { variant: 'warning', text: '開催間近' },
        'scheduled': { variant: 'primary', text: '開催予定' }
    };

    return (
        <Box
            className={`event-tile ${className}`}
            sx={{
                width: { xs: 'calc(50vw - 16px)', sm: '280px', md: '300px' },
                minHeight: { xs: '160px', sm: '180px', md: '200px' },
                cursor: 'pointer',
                margin: 1
            }}
            onClick={handleClick}
        >
            <Card style={{ width: '100%', height: '100%' }}>
                <Card.Body>
                    <div className="d-flex align-items-center justify-content-between mb-2">
                        <div className="d-flex align-items-center">
                            <Icon.Calendar size={window.innerWidth < 768 ? 20 : 24} className="me-2" />
                            <h6 className="mb-0" style={{ fontSize: window.innerWidth < 768 ? '14px' : '16px' }}>
                                {data.title || 'イベントタイトル'}
                            </h6>
                        </div>
                        <Badge bg={statusConfig[status].variant}>
                            {statusConfig[status].text}
                        </Badge>
                    </div>
                    
                    <p className="text-muted small mb-3" style={{ fontSize: window.innerWidth < 768 ? '12px' : '14px' }}>
                        {data.description || 'イベントの詳細が表示されます'}
                    </p>
                    
                    <div className="mb-2">
                        <small className="text-muted" style={{ fontSize: window.innerWidth < 768 ? '10px' : '12px' }}>
                            <Icon.Clock className="me-1" />
                            {formatDate(data.event_date)}
                        </small>
                    </div>
                    
                    {data.location && (
                        <div className="mb-2">
                            <small className="text-muted" style={{ fontSize: window.innerWidth < 768 ? '10px' : '12px' }}>
                                <Icon.GeoAlt className="me-1" />
                                {data.location}
                            </small>
                        </div>
                    )}
                    
                    <div className="d-flex justify-content-between align-items-center mt-3">
                        <small className="text-muted" style={{ fontSize: window.innerWidth < 768 ? '10px' : '12px' }}>
                            主催者: {data.user_name || 'Unknown'}
                        </small>
                        {data.participants_count && (
                            <small className="text-muted" style={{ fontSize: window.innerWidth < 768 ? '10px' : '12px' }}>
                                <Icon.People className="me-1" />
                                {data.participants_count}人参加
                            </small>
                        )}
                    </div>
                </Card.Body>
            </Card>
        </Box>
    );
};

export default EventTile;
